import React, { Component } from "react";
import styled from "styled-components";

import SignUpTitle from "./signUp/signUpTitle";
import SignUpForm from "./signUp/signUpForm";

import SignUpImg from "@/assets/signUp/signUp.png";

const Div = styled.div`
  width: 100vw;
  min-width: 130rem;
  height: 100vh;
  background-image: ${(props) => `url(${props.img})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .signUp-container {
    height: 64rem;
    width: 120rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
    align-items: center;
    justify-items: center;
  }
`;

class SignUp extends Component {
  render() {
    const { allSubs } = this.props;

    return (
      <Div img={SignUpImg}>
        <div className="signUp-container">
          <SignUpTitle />
          <SignUpForm match={this.props.match} allSubs={allSubs} />
        </div>
      </Div>
    );
  }
}

export default SignUp;
